import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { fetchOrganisations, type Organisation } from '@/api/organisations'
import { useAuthStore } from '@/stores/auth'
import { useOrgStore } from '@/stores/org'

export function useOrganisations() {
  const token = useAuthStore((s) => s.token)
  return useQuery({
    queryKey: ['organisations'],
    queryFn: fetchOrganisations,
    enabled: !!token,
  })
}

/** Houdt de selectedOrgId in sync met de gebruiker en beschikbare organisaties. */
export function useCurrentOrgId(): number | null {
  const user = useAuthStore((s) => s.user)
  const selectedOrgId = useOrgStore((s) => s.selectedOrgId)
  const setSelectedOrgId = useOrgStore((s) => s.setSelectedOrgId)
  const { data: orgs } = useOrganisations()

  useEffect(() => {
    if (!orgs || orgs.length === 0) return
    // Niet-superadmin → forceer eigen org
    if (user?.rol !== 'superadmin' && user?.organisation_id) {
      if (selectedOrgId !== user.organisation_id) {
        setSelectedOrgId(user.organisation_id)
      }
      return
    }
    // Superadmin zonder selectie → eerste org kiezen
    if (selectedOrgId == null || !orgs.find((o) => o.id === selectedOrgId)) {
      setSelectedOrgId(orgs[0].id)
    }
  }, [orgs, user, selectedOrgId, setSelectedOrgId])

  return selectedOrgId
}

export function useCurrentOrg(): Organisation | undefined {
  const orgId = useCurrentOrgId()
  const { data: orgs } = useOrganisations()
  return orgs?.find((o) => o.id === orgId)
}
